const invoice = {
	name: 'Invoice | Invoices',
	fields: {
		invoice_number: 'Invoice No.',
		invoice_date: 'Date',
		invoice_amount: 'Amount',
		authorized_date: 'Authorized on',
		authorized_amount: 'Authorized',
		due_date: 'Due date',
		booking_text: 'Booking text',
		accounting_year: {
			year: 'Year',
		},
		building_id: 'Property',
		comments_count: 'Comments',
	},
}

export default invoice
